import {MODAL_LOGIN} from "./modals";
import {globals} from "./utils/globals";
import {GlobalEvents} from "./events";

export class UserInfo {
	constructor(data) {
		this._data = {...data};
	}

	get id() {
		return +this._data['id'];
	}

	get roleId() {
		return +this._data['role_id'];
	}

	get isCustomer() {
		return !!this._data['is_customer'];
	}

	get url() {
		return this._data['url'];
	}

	get shortName() {
		return this._data['short_name'];
	}

	get fullName() {
		return this._data['full_name'];
	}

	get blogName() {
		return this._data['blog_name'];
	}

	get avatar() {
		return this._data['avatar'];
	}

	get avatarFull() {
		return this._data['avatar_full'];
	}

	get avatarExists() {
		return !!this._data['avatar_exists'];
	}

	get level() {
		return +this._data['level'];
	}
}

const data = globals('userInfo');

/**
 * Currently logged in user.
 * NULL means guest user.
 * @type {UserInfo}
 */
export let currentUser = data ? new UserInfo(data) : null;

/**
 * Executes given callback with logged in user.
 * If user is logged in - callback will be called immediately.
 * If not logged in - modal window will be shown and callback will be called only if user logged in.
 * @param callback Accepts {@link UserInfo} instance
 */
export function ensureLoggedIn(callback) {
	if (window.IS_LOGGED_IN) {
		callback(currentUser);
	}
	else {
		MODAL_LOGIN.show(result => {
			if (result) {
				// currentUser has been already updated in event handler below
				callback(currentUser);
			}
		});
	}
}

// catch global event and update user info
GlobalEvents.USER_LOGGED_IN.on((user) => {
	currentUser = new UserInfo(user);
	console.log('user logged in', currentUser);

	// update currentUser variable
	// (do it explicitly because the first line of current function does not update the global object)
	window.zde.currentUser = currentUser;

	// update legacy variables
	window.IS_LOGGED_IN = true;
	window.USER_ID = currentUser.id;
	window.USER_NAME = currentUser.fullName;
	window.USER_BLOG_NAME = currentUser.blogName;
	window.IS_CUSTOMER = currentUser.isCustomer;
});



// WEBPACK FOOTER //
// ./core/auth.js